import { render, staticRenderFns } from "./EditarProcesso.vue?vue&type=template&id=ba88f64e"
import script from "./EditarProcesso.vue?vue&type=script&lang=js"
export * from "./EditarProcesso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports